import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './styles/CheckoutReturnPage.css';

const CheckoutReturnPage: React.FC = () => {
  const [status, setStatus] = useState<string | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string>('');
  const { clearCart } = useCart();

  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:4242';

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    if (!sessionId) {
      setStatus('error');
      return;
    }

    fetch(`${API_ENDPOINT}/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
        
        // Clear cart if payment was successful
        if (data.status === 'complete') {
          clearCart();
        }
      })
      .catch((error) => {
        console.error('Error fetching session status:', error);
        setStatus('error');
      });
  }, [API_ENDPOINT, clearCart]);

  // If payment is still open, redirect back to checkout
  if (status === 'open') {
    return <Navigate to="/checkout" />;
  }

  // Payment successful
  if (status === 'complete') {
    return (
      <div className="return-page">
        <div className="success-container">
          <svg className="success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h1 className="success-title font-serif">Order Complete!</h1>
          <p className="success-message">
            A confirmation email will be sent to <strong>{customerEmail}</strong>.
          </p>
          <p className="success-submessage">
            If you have any questions, please email{' '}
            <a href="mailto:maplenookcrafts@gmail.comu" className="email-link">
              maplenookcrafts@gmail.com
            </a>
          </p>
          <a href="/" className="continue-shopping">
            Continue Shopping
          </a>
        </div>
      </div>
    );
  }

  // Error state
  if (status === 'error') {
    return (
      <div className="return-page">
        <div className="error-container">
          <svg className="error-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h1 className="error-title font-serif">Something went wrong</h1>
          <p className="error-message">
            We couldn't retrieve your order status. Please contact us if you need assistance.
          </p>
          <a href="/" className="continue-shopping">
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  // Loading state
  return (
    <div className="return-page">
      <div className="loading-container">
        <div className="spinner"></div>
        <p className="loading-text">Confirming your payment...</p>
      </div>
    </div>
  );
};

export default CheckoutReturnPage;